import React from 'react';
import {
  Checkbox,
  FormControl,
  InputLabel, ListItemText,
  OutlinedInput,
  Select,
  MenuItem, SelectChangeEvent,
} from '@mui/material';
import { errorNames, opportunityCategories, SustainableDevelopmentGoal } from '../../../../../utils/constants';
import { ErrorText } from '../../../../errorText/ErrorText';
import { borderInput } from '../../../../formAddress/formAddress.styles';
import { useStyles } from '../../modalEditProfile.styles';
import { IPropsControl } from '../../types';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export const GoalsAndCategoriesControl = (props: IPropsControl): JSX.Element => {
  const classes = useStyles();
  const { register, required, errors, goals, setGoals, category, setCategory } = props;

  const handleGoals = (e: SelectChangeEvent<string[]>): void => {
    setGoals && setGoals(e.target.value as Array<string>);
  };

  return (
    <>
      <div className={classes.checkboxBlock}>
        <FormControl className={classes.modalInp} fullWidth error={!!errors?.category} disabled>
          <InputLabel id="multiple-checkbox-category">Categories*</InputLabel>
          <Select
            labelId="multiple-checkbox-label-category"
            id="multiple-checkbox-category"
            {...register('category', {
              required,
            })}
            onChange={(e: SelectChangeEvent): void => setCategory && setCategory(e.target.value)}
            value={category}
            input={<OutlinedInput label="Categories*" sx={borderInput} />}
            renderValue={(selected: string): string => selected}
            MenuProps={MenuProps}
          >
            {Object.values(opportunityCategories).map((name) => (
              <MenuItem key={name} value={name}>
                <Checkbox checked={name === category} />
                <ListItemText primary={name} />
              </MenuItem>
            ))}
          </Select>
          <div className={classes.selectErrors}>
            {errors?.category?.type === 'required' && <ErrorText text={errorNames.categoryRequired} />}
          </div>
        </FormControl>
      </div>
      <div className={classes.checkboxBlock}>
        <FormControl className={classes.modalInp} fullWidth error={!!errors?.sustainableGoals} disabled>
          <InputLabel id="multiple-checkbox-category">SDG Goals*</InputLabel>
          <Select
            labelId="multiple-checkbox-label-category"
            id="multiple-checkbox-category"
            multiple
            value={goals}
            {...register('sustainableGoals', {
              required,
            })}
            onChange={handleGoals}
            input={<OutlinedInput label="SDG Goals*" sx={borderInput} />}
            renderValue={(selected: string[]): string => selected.join(', ')}
            MenuProps={MenuProps}
          >
            {Object.values(SustainableDevelopmentGoal).map((name) => (
              <MenuItem key={name} value={name}>
                <Checkbox checked={goals?.some((item) => item === name)} />
                <ListItemText primary={name} />
              </MenuItem>
            ))}
          </Select>
          <div className={classes.selectErrors}>
            {errors?.sustainableGoals?.type === 'required' && <ErrorText text={errorNames.goalsRequired} />}
          </div>
        </FormControl>
      </div>
    </>
  );
};
